import _ from 'lodash';
import { isTrackerPath } from './trackerUtil';
export function navigationDelegate() {}

navigationDelegate.prototype = {
  init() {
    //console.log("navigationDelegate init");
    this.observer = [];
    this.masternavi = document.getElementById('master-navi');
    this.masternavi_btn_close = document.querySelector(
      '#master-navi .btn--rail__show'
    );
    this.masternavi_btn_open = document.querySelector(
      '#master-navi .btn--rail__hide'
    );

    this.funcnavi1 = document.getElementById('func-navi--item1');
    this.funcnavi1_btn_open = document.querySelector(
      '#func-navi--item1 .btn--rail__show'
    );
    this.funcnavi1_btn_close = document.querySelector(
      '#func-navi--item1 .btn--rail__hide'
    );

    this.funcnavi2 = document.getElementById('func-navi--item2');
    this.funcnavi2_btn_open = document.querySelector(
      '#func-navi--item2 .btn--rail__show'
    );
    this.funcnavi2_btn_close = document.querySelector(
      '#func-navi--item2 .btn--rail__hide'
    );

    this.splitview = document.getElementById('splitview');
    this.splitview1_single = document.querySelector(
      '#func-navi--item1 .sys-splitview-single'
    );
    this.splitview1_multi = document.querySelector(
      '#func-navi--item1 .sys-splitview-multi'
    );
    this.splitview2_single = document.querySelector(
      '#func-navi--item2 .sys-splitview-single'
    );
    this.splitview2_multi = document.querySelector(
      '#func-navi--item2 .sys-splitview-multi'
    );

    this.message = document.querySelector('.global-header__message');
    this.message_close = document.querySelector(
      '.global-header__message .message__close'
    );

    this.conference = document.querySelector(
      '.global-header__conference #toggle-header'
    );

    this.buttons = [
      this.masternavi_btn_close,
      this.masternavi_btn_open,
      this.funcnavi1_btn_open,
      this.funcnavi1_btn_close,
      this.funcnavi2_btn_open,
      this.funcnavi2_btn_close,
      this.splitview1_single,
      this.splitview1_multi,
      this.splitview2_single,
      this.splitview2_multi,
      this.message_close,
    ];

    this.initEvent();
  },

  initEvent() {
    //console.log("navigationDelegate initEvent");
    var _this = this;
    _.each(this.buttons, function(button) {
      if (button) {
        button.addEventListener('click', function(e) {
          /*
          Reactのstateで管理しているイベントは遅れて変更されるので、
          イベントも遅らせる
          */
          setTimeout(function() {
            _this.emit(e);
          }, 1);
        });
      }
    });
    window.addEventListener('resize', function(e) {
      _this.emit(e);
    });
    window.addEventListener('load', function(e) {
      _this.emit(e);
    });

    if (this.conference) {
      this.conference.addEventListener('change', function(e) {
        setTimeout(function() {
          _this.emit(e);
        }, 1);
      });
    }
  },

  observeNavi(func) {
    this.observer.push(func);
  },

  forceUpdate() {
    this.emit();
  },

  emit(e) {
    var _this = this;
    var _param = _this.getNavigationStatus();
    _.each(this.observer, function(func) {
      func(e, _param);
    });
  },

  getNavigationStatus() {
    // 車両管理の機能一覧などは車両管理側で管理する
    if (isTrackerPath()) {
      return {
        masternavi: this.masternavi ? this.masternavi.classList.contains('show') : false,
        funcnavi1: false,
        funcnavi2: false,
        splitview1: false,
        splitview2: false,
        message: this.message ? this.message.classList.contains('show') : null,
      };
    }

    var splitview1 = false;
    var splitview2 = false;
    var splitview_classlist = this.splitview.classList;

    if (splitview_classlist.contains('split--1-1')) {
      splitview1 = true;
      splitview2 = true;
    } else if (splitview_classlist.contains('split--1-0')) {
      splitview1 = true;
      splitview2 = false;
    } else if (splitview_classlist.contains('split--0-1')) {
      splitview1 = false;
      splitview2 = true;
    }

    //console.log("NavigationDElegate = " , this.masternavi , this.masternavi.classList.contains("show") );

    return {
      masternavi: this.masternavi.classList.contains('show'),
      funcnavi1: this.funcnavi1.classList.contains('show'),
      funcnavi2: this.funcnavi2.classList.contains('show'),
      splitview1,
      splitview2,
      message: this.message ? this.message.classList.contains('show') : null,
    };
  },

  //navigationのRect情報を返す。
  getNavigationRect(status) {
    let rects = {};

    for (let id in status) {
      if (status[id] && this[id]) {
        rects[id] = this[id].getBoundingClientRect();
      }
    }

    return rects;
  },
};



// WEBPACK FOOTER //
// ./src/utilities/navigationDelegate.js